import { i18n } from "@/plugins/i18n";
import moment from "moment"


export const getDateTime = (dateTime) => {
    if (!dateTime) return ''

    const m = moment(dateTime); m.locale(i18n.locale);
    return m.format('DD.MM.YYYY HH:mm')
}

export const getDate = (dateTime) => {
    if (!dateTime) return ''

    const m = moment(dateTime); m.locale(i18n.locale);
    return m.format('DD.MM.YYYY')
}

export const getShortDate = (dateTime) => {
    if (!dateTime) return ''

    const m = moment(dateTime); m.locale(i18n.locale);
    return m.format('DD.MM.')
}

export const getShortMonthName = (dateTime) => {
    if (!dateTime) return ''

    const m = moment(dateTime); m.locale(i18n.locale);
    return m.format('MMM')
}

export const getMonthName = (dateTime) => {
    if (!dateTime) return ''

    const m = moment(dateTime); m.locale(i18n.locale);
    return m.format('MMMM')
}

export const getDayOfMonth = (dateTime) => {
    if (!dateTime) return ''

    const m = moment(dateTime); m.locale(i18n.locale);
    return m.format("D");
}

export const getTime = (dateTime) => {
    if (!dateTime) return '';

    const m = moment(dateTime); m.locale(i18n.locale);
    return m.format('HH:mm');
}


export const getDayOfWeek = (dateTime) => {
    if (!dateTime) return ''

    const m = moment(dateTime); m.locale(i18n.locale);
    return m.format('dddd');
}

export const isSameDay = (date1, date2) => {
    if (!date1 || !date2)
        return false

    return moment(date1).isSame(date2, 'day');
}